import { CashBookFilters } from '../../shared/types/reportFilters/cashBook';

export const validateCashBookFilters = (data: CashBookFilters, errors: any) => {
  let isValid = true;

  if (data.fromDate === undefined) {
    errors = { ...errors, fromDate: 'From date is required' };
    isValid = false;
  } else {
    delete errors.fromDate;
  }

  if (data.toDate === undefined) {
    errors = { ...errors, toDate: 'To Date is required' };
    isValid = false;
  } else {
    delete errors.toDate;
  }

  if (data.account === undefined) {
    errors = { ...errors, account: 'Account is required' };
    isValid = false;
  } else {
    delete errors.account;
  }

  return { isValid, errs: errors };
};
